export const CREATE_MASTER = "CREATE_MASTER";
export const FETCH_MASTERS = "FETCH_MASTERS";
export const FETCH_MASTER = "FETCH_MASTER";
export const EDIT_MASTER = "EDIT_MASTER";
export const DELETE_MASTER = "DELETE_MASTER";
export const FETCH_MASTER_DDL = "FETCH_MASTER_DDL";
